import Link from "next/link";
import React from "react";
import { ordinalValue } from "../lib/helpers";
import { ComponentHeader } from "./ComponentHeader";
import ImageWithFallback from "./ImageWithFallback";

const ScoreSummaryPools = (props) => {
  const pools = props.pools;
  return (
    <React.Fragment>
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden ring-1 ring-black ring-opacity-5">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-black">
              <tr>
                <th
                  scope="col"
                  className="p-2 pr-3 text-left text-[14px] font-bold shadow-lg text-white"
                >
                  Pool
                </th>
                <th
                  scope="col"
                  className="p-2 px-3 text-[14px] font-bold shadow-lg text-white text-right md:table-cell"
                >
                  Position
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {pools &&
                pools.map((pool) => (
                  <tr key={pool.name}>
                    <td className="font-serif p-2.5 pr-3 font-medium text-[14px] text-gray-900 inline-flex items-center">
                      <Link href={`/pool/${pool.id}`}>
                        <a className="hover:underline">{pool.name}</a>
                      </Link>
                    </td>
                    <td className="whitespace-nowrap font-serif px-3 py-2.5 text-gray-500 text-[14px] text-right">
                      {pool.position?.rank}
                      <sup>{ordinalValue(pool.position?.rank)}</sup>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScoreSummaryPools;
